/**
 * Channel types matching the DB enum `notifications.channel_type`.
 * Keep in sync with `libs/db/src/schema/notifications.ts`.
 */
export const CHANNEL_TYPES = ['in_app', 'webhook', 'email', 'mobile_push', 'slack', 'teams'] as const;
export type ChannelType = (typeof CHANNEL_TYPES)[number];

/**
 * Delivery statuses matching the DB enum `notifications.delivery_status`.
 */
export const DELIVERY_STATUSES = ['pending', 'queued', 'sending', 'delivered', 'failed', 'skipped'] as const;
export type DeliveryStatus = (typeof DELIVERY_STATUSES)[number];

/**
 * Notification types matching the DB enum `notifications.notification_type`.
 */
export const NOTIFICATION_TYPES = ['info', 'warning', 'error', 'success'] as const;
export type NotificationType = (typeof NOTIFICATION_TYPES)[number];

/**
 * Priority levels matching the DB enum `notifications.notification_priority`.
 */
export const NOTIFICATION_PRIORITIES = ['low', 'normal', 'high', 'urgent'] as const;
export type NotificationPriority = (typeof NOTIFICATION_PRIORITIES)[number];
